import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import AddressTypeSelectNew from "./AddressTypeSelectNew";
import TextField from "@material-ui/core/TextField";
import Style from "react-style-tag/lib/Style";
import ImageField from "./ImageField";

class PickupExtraInfo extends Component {
  renderError = (id) => {
    const { language, countries } = this.props;
    const addressType = this.props.selectedAddressType || 0;
    let selectedCountry = countries
      ? countries.find((country) => country.id == this.props.address.country)
      : null;
    if (!selectedCountry) {
      selectedCountry = { name: "Kuwait" };
    }
    if (this.props.blockError && id === "block")
      return language == "english"
        ? `Please enter a ${
            selectedCountry.name == "Qatar"
              ? "zone"
              : selectedCountry.name === "Egypt"
              ? "area"
              : "block"
          }`
        : `الرجاء ادخال رقم ${
            selectedCountry.name == "Qatar"
              ? "المنطقة"
              : selectedCountry.name === "Egypt"
              ? "المنطقة"
              : selectedCountry.name === "Bahrain"
                ? "المجمع"
                : "القطعة"
          }`;
    else if (this.props.streetError && id === "street")
      return language == "english"
        ? "Please enter the street"
        : "الرجاء ادخال رقم الشارع";
    else if (this.props.buildingError && id === "building")
      return language == "english"
        ? `Please enter the ${
            addressType == 0 ? "house number" : "building number"
          }`
        : `الرجاء ادخال رقم ${addressType == 0 ? "المنزل" : "المبنى"}`;
    else if (
      this.props.apartmentError &&
      id === "apartment" &&
      addressType !== 0
    )
      return language == "english"
        ? `Please enter the ${
            addressType == 1 ? "apartment number" : "office number"
          }`
        : `الرجاء ادخال رقم ${addressType == 0 ? "الشقة" : "المكتب"}`;
    else if (this.props.floorError && id === "floor" && addressType !== 0)
      return language == "english"
        ? `Please enter the floor number`
        : `الرجاء ادخال رقم الطابق`;
    else if (this.props.additionalError && id === "additional")
      return language == "english"
        ? `Cannot exceed 254 letters`
        : `تجاوزت العدد الأقصى للحروف ٢٥٤`;
    else if (
      this.props.ksaNationalCodeError &&
      id === "paci" &&
      selectedCountry.name === "Saudi Arabia"
    )
      return language == "english"
        ? `Please enter a valid national address code`
        : `الرجاء إدخال رمز العنوان الوطني صحيح`;
    return "";
  };
  render() {
    const {
      language,
      customTexts,
      themeColor,
      address,
      collect_home_pictures,
      countries,
      areas,
      branch_delivery_charges,
      settings,
    } = this.props;

    let selectedCountry = countries
      ? countries.find((country) => country.id == this.props.address.country)
      : null;
    if (!selectedCountry) {
      selectedCountry = { name: "Kuwait" };
    }
    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area,
      );
      if (selectedArea) {
        selectedArea = {
          name: selectedArea.area,
          province_name: selectedArea.province_en,
        };
      }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    const international = selectedCountry.name === "International";
    const alHamraSituationTing =
      selectedArea &&
      ([
        "arraya tower",
        "arraya center",
        "nbk tower",
        "assima mall",
        "mazaya tower",
        "international hospital",
      ].some((a) => selectedArea.name.toLowerCase().includes(a)) ||
        selectedArea.province_name === "Offices") &&
      address.selectedDeliveryType === 0;

    const isInternationalHospital =
      alHamraSituationTing &&
      selectedArea.name.toLowerCase().includes("international hospital");

    const selectedAddressType = this.props.selectedAddressType || 0;

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };

    const useAddressLines =
      selectedCountry.name === "International" ||
      selectedArea?.province_name === "Kashtat";

    let fields = [
      {
        name:
          selectedCountry.name === "Qatar"
            ? "Zone"
            : selectedCountry.name === "Egypt"
            ? "Area"
            : useAddressLines
              ? "Address line 1"
              : "Block",
        ar_name:
          selectedCountry.name === "Qatar"
            ? "منطقة"
            : selectedCountry.name === "Egypt"
            ? "منطقة"
            : selectedCountry.name === "Bahrain"
              ? "مجمع"
              : useAddressLines
                ? "الخط العنواني 1"
                : "قطعة",
        required:
          selectedCountry.name === "Qatar" && settings.force_geolocation
            ? false
            : true,
        id: "block",
      },
      {
        name: useAddressLines ? "Address line 2" : "Street",
        ar_name: useAddressLines ? "الخط العنواني 2" : "شارع",
        required:
          selectedCountry.name === "Qatar" && settings.force_geolocation
            ? false
            : true,
        id: "street",
      },
      {
        name: selectedAddressType === 0 ? "House #" : "Building Name/#",
        ar_name: selectedAddressType === 0 ? "رقم المنزل" : "رقم/اسم المبنى",
        required: true,
        id: "building",
      },
      {
        name: selectedCountry.name === "International" ? "Postcode" : "Avenue",
        ar_name:
          selectedCountry.name === "International" ? "الرمز البريدي" : "جادة",
        required: false,
        id: "avenue",
      },
      {
        name: "Floor",
        ar_name: "طابق",
        required:
          selectedAddressType !== 1 && !isInternationalHospital ? true : false,
        id: "floor",
        excludeInAddressType: 0,
      },
      {
        name:
          selectedAddressType === 1
            ? "Apartment #"
            : isInternationalHospital
              ? "Room #"
              : "Office #",
        ar_name:
          selectedAddressType === 1
            ? "شقة"
            : isInternationalHospital
              ? "غرفة"
              : "مكتب",
        required:
          selectedCountry.name === "Qatar"
            ? selectedAddressType === 0
              ? false
              : true
            : selectedAddressType !== 1 && !isInternationalHospital
              ? true
              : false,
        id: "apartment",
        excludeInAddressType: 0,
      },
      {
        name:
          selectedCountry.name === "Saudi Arabia"
            ? "National Address Code"
            : "PACI",
        ar_name:
          selectedCountry.name === "Saudi Arabia"
            ? "العنوان الوطنى المختصر"
            : "الرقم المدني للمبنى",
        id: "paci",
        required: selectedCountry.name === "Saudi Arabia",
        country: "Kuwait",
      },
      {
        name: "Additional",
        ar_name: "اضافي",
        required: false,
        id: "additional",
      },
    ];
    if (selectedCountry.name === "Qatar") {
      fields = fields.filter((f) => f.id !== "avenue" && f.id !== "paci");
    }
    if (selectedCountry.name === "Saudi Arabia") {
      fields = fields.filter((f) => f.id !== "avenue");
      fields.sort((a, b) => {
        if (a.id == "paci") return -1;
        if (b.id == "paci") return 1;
        return 0;
      });
    }
    if (selectedCountry.name === "Bahrain") {
      fields = fields.filter((f) => f.id !== "paci");
    }
    if (selectedCountry.name === "Egypt") {
      fields = fields.filter((f) => f.id !== "paci" && f.id !== "avenue");
    }
    if (selectedCountry.name === "UAE") {
      fields = fields.filter(
        (f) => f.id !== "paci" && f.id !== "avenue" && f.id !== "block",
      );
    }
    if (selectedCountry.name === "International") {
      fields = fields.filter((f) =>
        ["block", "street", "avenue"].includes(f.id),
      );
    }
    if (useAddressLines) {
      fields = fields.filter((f) => ["block", "street"].includes(f.id));
    }

    if (alHamraSituationTing) {
      fields = fields.filter(
        (f) =>
          f.id !== "block" &&
          f.id !== "building" &&
          f.id !== "street" &&
          f.id !== "avenue" &&
          f.id !== "paci" &&
          f.id !== "additional",
      );
      fields = fields.map((f) => ({ ...f, required: true }));
    }
    if (settings.hide_block) {
      fields = fields.filter((f) => f.id !== "block");
    }

    return (
      <div style={{ marginTop: 30 }}>
        <Style>
          {`.MuiInput-underline:before {
                  border-bottom: 1px solid #0000001f !important;
              }`}
        </Style>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic" ? "تفاصيل العنوان" : "Address Details"}
        </p>
        <div
          style={{
            minHeight: 100,
            direction: language == "english" ? "ltr" : "rtl",
            backgroundColor: "white",
            padding: "25px 17px",
            paddingTop:
              alHamraSituationTing || international || useAddressLines ? 0 : 25,
          }}
          className="w-100 bordered"
        >
          {!alHamraSituationTing && !international && !useAddressLines && (
            <AddressTypeSelectNew
              selectedAddressType={selectedAddressType}
              onChangeAddressType={(val) => this.props.onChangeAddressType(val)}
            />
          )}
          <div
            className={
              !alHamraSituationTing && !international && !useAddressLines
                ? "mt-1"
                : "mt-3"
            }
          >
            {fields
              .filter(
                (field) => field.excludeInAddressType !== selectedAddressType,
              )
              .map((field) => (
                <TextField
                  id={`${field.id}TextField`}
                  label={
                    <span style={{ fontSize: "1rem" }}>
                      {language === "arabic" ? field.ar_name : field.name}{" "}
                      {field.required ? "*" : ""}
                    </span>
                  }
                  color="primary"
                  key={`${field.id}Key`}
                  name={field.id}
                  fullWidth
                  onChange={this.props.handleChange}
                  value={this.props[field.id]}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  style={{ margin: "10px 0px" }}
                  helperText={this.renderError(field.id)}
                  error={
                    (this.props.blockError && field.id === "block") ||
                    (this.props.streetError && field.id === "street") ||
                    (this.props.buildingError && field.id === "building") ||
                    (this.props.apartmentError && field.id === "apartment") ||
                    (this.props.floorError && field.id === "floor") ||
                    (this.props.ksaNationalCodeError && field.id === "paci") ||
                    (this.props.additionalError && field.id === "additional")
                  }
                />
              ))}
          </div>

          {collect_home_pictures && (
            <div>
              <ImageField
                handleImageUpload={this.props.handleImageUpload}
                home_picture={this.props.home_picture}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    customTexts: state.store.store.settings.custom_texts,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
    branch: state.branch,
    areas: state.store.store.areas,
    collect_home_pictures: state.store.store.settings.collect_home_pictures,
    countries: state.store.store.countries,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (obj) => dispatch({ type: "MODIFY_ADDRESS", payload: obj }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PickupExtraInfo);
